import React from 'react'
import Gallery from '../elements/Gallery'

export default function GalleryPage() {
  return (
    <Gallery/>
  )
}
